import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { CodeTypeDataComponent } from '../code-type-data/code-type-data.component';

@Component({
  selector: 'app-tehasil-dialogbox',
  templateUrl: './tehasil-dialogbox.component.html',
  styleUrls: ['./tehasil-dialogbox.component.scss']
})
export class TehasilDialogboxComponent implements OnInit {
  TehasilForm: FormGroup;
  TehasilSearchForm: FormGroup;
  DistrictList: any;
  dialogRef: MatDialogRef<any>;
  filteredListDistrict: any;
  submitButton = true;
  editButton = false;
  deleteButton = false;
  submitpayload
  APIService: string;
  userPermission: any;
  utp: any;
  tehasilCreate = true;
  tehasilUpdate = true;
  tehasilDelete = true;
  ureadonly = false;
  dreadonly =false;
  constructor(public umsService: UmsService,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef2: MatDialogRef<TehasilDialogboxComponent>,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,) { this.APIService = environment.serviceUrl;}

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Tehasil' && element.PCreate == false) {
          this.tehasilCreate = false;
        }
        if (element.PageName == 'Tehasil' && element.PUpdate == false) {
          this.tehasilUpdate = false;
        }
        if (element.PageName == 'Tehasil' && element.PDelete == false) {
          this.tehasilDelete = false;
        }
      });
    }
    this.submitButton = true;
    this.TehasilForm = this.fb.group({
      TsCode: new FormControl('',[Validators.pattern('^[a-zA-z0-9]*$'),Validators.required]),
      TsName: new FormControl('',[Validators.pattern('^[a-zA-z0-9 - &\\s]*$'),Validators.required]),
      DsCode: new FormControl('',Validators.required),
    });
    if (this.data.key == "Edit") {
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key)
    }

    this.fetchDistrict()
  }

  fetchDistrict() {
    const payload = {};
    this.umsService.getDistrict(payload).subscribe(res => {
      if (res.status) {
        this.DistrictList = res.data;
        this.filteredListDistrict = this.DistrictList.slice();
      }
    })
  }


  submit() {
    if (this.TehasilForm.invalid) {
      this.TehasilForm.get('TsCode').markAsTouched();
      this.TehasilForm.get('TsName').markAsTouched();
      this.TehasilForm.get('DsCode').markAsTouched();
      return;
    } else {
      this.createTown();
    }
  }

  createTown() {
    this.spinner.show();
    this.submitpayload = this.TehasilForm.value;
    this.umsService.addTehasil(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      } else {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }

  prepopulation(id) {
    const payload = {};
    // tslint:disable-next-line:no-string-literal
    payload['TehsilId'] = id.TehsilId;
    // payload['TnName'] = id.TnName;
    // payload['TnDsCode'] = id.TnDsCode;  
    // this.isReadonly = true;
    // this.umsService.getTehasil(payload).subscribe((res) => {
      // let data = res.data[0];
      // if (res.status) {
        this.editButton = true;
        this.submitButton = false;
        this.deleteButton = false;
        this.ureadonly = true;
        this.dreadonly =false;
        this.TehasilForm = this.fb.group({
          TsCode: new FormControl(id.TsCode,[Validators.pattern('^[a-zA-z0-9]*$'),Validators.required]),
          TsName: new FormControl(id.TsName,[Validators.pattern('^[a-zA-z0-9 - &\\s]*$'),Validators.required]),
          DsCode: new FormControl(id.DsCode,Validators.required),
        });

      // } 
      // else {
      //   this.umsService.openSnackbar(res.message);
      // }
    // });
  }

  update() {
    if (this.TehasilForm.invalid) {
      this.TehasilForm.get('TsCode').markAsTouched();
      this.TehasilForm.get('TsName').markAsTouched();
      this.TehasilForm.get('DsCode').markAsTouched();
      return;
    } else {
      this.updateTown();
    }
  }

  updateTown() {
    this.spinner.show();
    this.submitpayload = this.TehasilForm.value;
    this.umsService.updateTehasil(this.submitpayload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      } else {
        this.spinner.hide();
        let data = {}
        data['message'] = res.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
        //   this.ngOnInit();
        // });
      }
    }, (ERROR: HttpErrorResponse) => {
      let data = {}
      this.spinner.hide();
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-check'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

    });
  }

  prepopulationForDelete(id) {
    const payload = {};
    // tslint:disable-next-line:no-string-literal

    // payload['TehsilId'] = id.TehsilId;
    // payload['TnName'] = id.TnName;
    // payload['TnDsCode'] = id.TnDsCode;  
    // this.isReadonly = true;
    // this.umsService.getTehasil(payload).subscribe((res) => {
      // let data = res.data[0];
      // if (res.status) {
        this.editButton = false;
        this.submitButton = false;
        this.deleteButton = true;
        this.ureadonly = false;
        this.dreadonly = true;
        this.TehasilForm = this.fb.group({
          TsCode: new FormControl(id.TsCode,Validators.required),
          TsName: new FormControl(id.TsName,Validators.required),
          DsCode: new FormControl(id.DsCode,Validators.required),
        });

      // } 
      
      // else {
      //   this.umsService.openSnackbar(res.message);
      // }
    // });
  }

  openConformationModalBox() {
    let data = {}
    data['message'] = 'Are You Sure You Want To Delete This Record ?'
    data['title'] = 'Alert'
    data['icon'] = 'fa fa-question'
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result == 'yes') {
        this.deletedata(this.TehasilForm.value);
      } else {
        this.ngOnInit();
      }
    });
  }

  deletedata(id) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        TsCode: id.TsCode,
        TsName: id.TsName,
        DsCode: id.DsCode,

      },
    };
    this.httpClient.delete(this.APIService + '/masters/Tehsil', options)
      .subscribe((s) => {
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          // this.ngOnInit();
          this.dialogRef2.close();
        });
      }, (ERROR: HttpErrorResponse) => {
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }


 
}
